import { jsx } from "react/jsx-runtime";
import { createContext, useCallback } from "react";
import { noOp } from "../../utils/noOp.js";
const ScrollToTopContext = createContext({ scrollToTop: noOp });
function ScrollToTopContextProvider(props) {
  var _a;
  const { containerRef } = props, containerRect = (_a = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a.getBoundingClientRect(), scrollToTop = useCallback(() => {
    window.scroll({ top: (containerRect == null ? void 0 : containerRect.top) ?? 0, left: (containerRect == null ? void 0 : containerRect.left) ?? 0, behavior: "smooth" });
  }, [containerRect == null ? void 0 : containerRect.top, containerRect == null ? void 0 : containerRect.left]);
  return /* @__PURE__ */ jsx(ScrollToTopContext.Provider, { value: { scrollToTop }, children: props.children });
}
export {
  ScrollToTopContext,
  ScrollToTopContextProvider
};
//# sourceMappingURL=ScrollToTopContext.js.map
